// extracted by mini-css-extract-plugin
module.exports = {"primary-list":"MenuPrimary_primary-list__ULu4L","primary-list__item":"MenuPrimary_primary-list__item__uBr4p"};